import { Inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { GeneralMapActions } from './action-types'
import { filter, map, take, tap } from 'rxjs/operators'
import { OpenLayersLayerService } from '../../../../../shared/open-layers/open-layers-layer.service'
import { LpisUserSubjectSearchActions } from '../../../../../features/map/lpis-user-subject-search/state/action-types'
import { MapLpisLayerService } from '../../../../../features/map/services/map-lpis-layer.service'
import { GeneralMapHelper } from '../services/general-map.helper'
import { MapLayerSettingsStorageService } from '../../../../../core/storage/map-layer-settings-storage.service'
import {
    selectGeneralMapLayersConfig,
    selectGeneralMapParcelContractEndingDate, selectGeneralMapSaveLayersConfig,
} from './general-map.selectors'
import { OpenLayersGeoJsonService } from '../../../../../shared/open-layers/open-layers-geo-json.service'
import VectorSource from 'ol/source/Vector'
import { OpenLayersMapService } from '../../../../../shared/open-layers/open-layers-map.service'
import { GeneralMapLayerDefinitionsService } from '../services/general-map-layer-definitions.service'
import { AuthContextStorageService } from '../../../../../core/auth/auth-context-storage.service'
import { MapInfoBoxTypeEnum } from '../../../../../features/map/info-box/map-info-box-type.enum'
import { GeneralMapLayerService } from '../services/general-map-layer.service'
import cloneDeep from 'lodash/cloneDeep'
import { GeneralMapService } from '../services/general-map.service'

@Injectable()
export class GeneralMapEffects {

    // beforeSetMap$: Observable<any>
    // initMap$: Observable<any>
    // afterSetMap$: Observable<any>
    openInfoBox$: Observable<any>
    createMapSimpleFeatureGroupLayerIfNotExists$: Observable<any>
    createMapSimpleFeatureGroupLayerIfNotExistsWithUpdatedFeatureAreas$: Observable<any>
    setParcelContractEndingDate$: Observable<any>
    setParcelContractEndingDateVisible$: Observable<any>
    closeInfobox$: Observable<any>
    lpisUserSelection$: Observable<any>
    updateLayerConfigPropertyByLayerId$: Observable<any>
    setMapSimpleLayersConfigPropertyByLayerId$: Observable<any>

    constructor(
        @Inject(Actions) private actions$: Actions,
        @Inject(Store) private store: Store,
        @Inject(OpenLayersLayerService) private openLayersLayerService: OpenLayersLayerService,
        @Inject(MapLpisLayerService) private mapLpisLayerService: MapLpisLayerService,
        @Inject(GeneralMapHelper) private generalMapHelper: GeneralMapHelper,
        @Inject(MapLayerSettingsStorageService) private mapLayerSettingsStorageService: MapLayerSettingsStorageService,
        @Inject(OpenLayersGeoJsonService) private openLayersGeoJsonService: OpenLayersGeoJsonService,
        @Inject(OpenLayersMapService) private openLayersMapService: OpenLayersMapService,
        @Inject(GeneralMapLayerDefinitionsService) private generalMapLayerDefinitionsService: GeneralMapLayerDefinitionsService,
        @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
        @Inject(GeneralMapLayerService) private generalMapLayerService: GeneralMapLayerService,
        @Inject(GeneralMapService) private generalMapService: GeneralMapService,
    ) {
        this.openInfoBox$ = createEffect(() => this.actions$.pipe(
            ofType(GeneralMapActions.openInfoBox),
            map(({ mapId, infoBoxType }) => GeneralMapActions.setMapInfoBox({ mapId, showedInfoBox: infoBoxType })),
        ))

        // this.initMap$ = createEffect(() => this.actions$.pipe(
        //     ofType(GeneralMapActions.beforeSetMap),
        //     map(({ mapId }) => GeneralMapActions.initMap({ mapId })),
        // ))

        // this.beforeSetMap$ = createEffect(() => this.actions$.pipe(
        //     ofType(GeneralMapActions.beforeSetMap),
        //     concatMap(({ mapId, layersConfig, mapOptions }) => {
        //         if (mapOptions?.saveLayersVisibility) {
        //             const loadedConfig = this.loadLayers(mapId, mapOptions.storagePrefix)
        //             if (loadedConfig) {
        //                 this.initCustomLpisLayersInConfig(loadedConfig, layersConfig)
        //                 this.updateScopeConfigVisibility(loadedConfig, layersConfig)
        //             }
        //         }
        //
        //         const layers = this.openLayersLayerService.buildLayersFromConfig(layersConfig)
        //         const map = new Map({
        //             target: mapId,
        //             layers: layers,
        //             controls: mapOptions.controls,
        //             interactions: mapOptions.interactions,
        //             view: mapOptions.view,
        //             maxTilesLoading: 128,
        //             keyboardEventTarget: mapOptions.keyboardEventTarget,
        //         })
        //         map.set('id', mapId)
        //
        //         return [
        //             GeneralMapActions.setMap({ mapId: mapId, map: map, layersConfig, mapOptions }),
        //             GeneralMapActions.setLayersConfig({ mapId: mapId, config: layersConfig }),
        //             GeneralMapActions.setPadding({ mapId: mapId, padding: mapOptions.padding || 70 }),
        //         ]
        //     }),
        // ))

        // this.afterSetMap$ = createEffect(() => this.actions$.pipe(
        //     ofType(GeneralMapActions.setMap),
        //     tap(({ mapId, layersConfig, mapOptions }) => {
        //         // ==> lpisConfig
        //         const lpisConfig = this.generalMapHelper.getSelectorConfigById(layersConfig, 'farmer-blocks-foreign')
        //         if (lpisConfig && lpisConfig.visible) {
        //             this.store.dispatch(GeneralMapActions.lpisUserSelection({
        //                 mapId,
        //                 visible: lpisConfig.isSet,
        //                 lpisConfig,
        //                 doNotUpdateMap: true,
        //             }))
        //         } else if (lpisConfig) {
        //             this.store.dispatch(GeneralMapActions.lpisUserSelection({ mapId, visible: null, lpisConfig, doNotUpdateMap: true }))
        //         }
        //         // ==> parcelEndContractsConfig
        //         const parcelEndContractsConfig = this.generalMapHelper.getSelectorConfigById(layersConfig, 'parcely-na-koncicich-smlouvach')
        //         if (parcelEndContractsConfig && parcelEndContractsConfig.visible) {
        //             const isSet = this.mapLayerSettingsStorageService.getSavedSettings('parcely-na-koncicich-smlouvach', 'isSet')
        //
        //             if (isSet) {
        //                 const expDate = this.mapLayerSettingsStorageService.getSavedSettings('parcely-na-koncicich-smlouvach', 'expDate')
        //                 this.store.dispatch(GeneralMapActions.setParcelContractEndingDate({ mapId, expDate: expDate }))
        //             }
        //
        //             this.store.dispatch(GeneralMapActions.setParcelContractEndingDateVisible({ mapId, visible: true, isSet }))
        //         }
        //
        //         if (mapOptions.saveLayersVisibility) {
        //             this.store.dispatch(GeneralMapActions.setMapSimpleSaveLayersVisibility({
        //                 mapId,
        //                 value: mapOptions.saveLayersVisibility,
        //             }))
        //         }
        //
        //         if (mapOptions.storagePrefix) {
        //             this.store.dispatch(GeneralMapActions.setMapSimpleStoragePrefix({ mapId, prefix: mapOptions.storagePrefix }))
        //         }
        //     }),
        // ), { dispatch: false })

        this.createMapSimpleFeatureGroupLayerIfNotExists$ = createEffect(() => this.actions$.pipe(
            ofType(GeneralMapActions.createMapSimpleFeatureGroupLayerIfNotExists),
            tap((action) => {
                if (!this.generalMapService.hasFeatureGroupLayersLayer(action.mapId, action.layerName)) {
                    const vectorSource = new VectorSource()
                    const vectorLayer = this.openLayersLayerService.createVectorLayer(action.layerName, vectorSource, action.zIndex)
                    this.generalMapService.setFeatureGroupLayersLayer(action.mapId, action.layerName, vectorLayer)
                }
            }),
        ), { dispatch: false })

        this.createMapSimpleFeatureGroupLayerIfNotExistsWithUpdatedFeatureAreas$ = createEffect(() => this.actions$.pipe(
            ofType(GeneralMapActions.createFeatureGroupLayerIfNotExistsWithUpdatedFeatureAreas),
            tap((action) => {
                if (!this.generalMapService.hasFeatureGroupLayersLayer(action.mapId, action.layerName)) {
                    const vectorSource = this.openLayersGeoJsonService.createVectorSourceWithUpdatedFeatureAreas()
                    const vectorLayer = this.openLayersLayerService.createVectorLayer(action.layerName, vectorSource, action.zIndex)
                    this.generalMapService.setFeatureGroupLayersLayer(action.mapId, action.layerName, vectorLayer)
                }
            }),
        ), { dispatch: false })

        this.setParcelContractEndingDate$ = createEffect(() => this.actions$.pipe(
            ofType(GeneralMapActions.setParcelContractEndingDate),
            tap(action => {
                this.generalMapService.map$.pipe(
                    filter(map => map[action.mapId] !== null && map[action.mapId] !== undefined), // Check if map is not null or undefined
                    take(1), // Execute the code only once
                ).subscribe(map => {
                    this.openLayersMapService.removeLayerByName('parcely-na-koncicich-smlouvach', map[action.mapId])

                    const newLayer = this.generalMapLayerDefinitionsService.getLayerParcelyNaKoncicichSmlouvach(this.authContextStorageService.getProjectKey(), action.expDate)
                    const layer = this.openLayersLayerService.buildLayerFromDefinition(newLayer, true)
                    if (layer) {
                        map[action.mapId].addLayer(layer)
                    }
                })
            }),
        ), { dispatch: false })

        this.setParcelContractEndingDateVisible$ = createEffect(() => this.actions$.pipe(
            ofType(GeneralMapActions.setParcelContractEndingDateVisible),
            tap(({ mapId, visible, isSet }) => {
                this.store.dispatch(
                    GeneralMapActions.setMapSimpleParcelContractEndingDateVisible({ mapId: mapId, value: visible && isSet }),
                )
                this.store.dispatch(visible && isSet ?
                    GeneralMapActions.setMapInfoBox({ mapId, showedInfoBox: MapInfoBoxTypeEnum.lpisEndingContract }) : // openInfoBox
                    GeneralMapActions.closeInfobox({ mapId, infoBoxType: MapInfoBoxTypeEnum.lpisEndingContract }))
                this.store.dispatch(
                    GeneralMapActions.updateLayerConfigPropertyByLayerId({
                        mapId,
                        layerId: 'parcely-na-koncicich-smlouvach',
                        property: 'isSet',
                        value: isSet,
                    }))
                this.mapLayerSettingsStorageService.setSavedSettings('parcely-na-koncicich-smlouvach', 'isSet', isSet)

                if (isSet === false && visible === true) {
                    this.store.dispatch(GeneralMapActions.setParcelContractEndingDate({ mapId, expDate: null }))
                } else if (isSet === true && visible === true) {
                    this.store.select(selectGeneralMapParcelContractEndingDate(mapId)).pipe(
                        take(1))
                        .subscribe(expDate => {
                            this.store.dispatch(GeneralMapActions.setParcelContractEndingDate({ mapId, expDate: expDate }))
                        })
                }
            }),
        ), { dispatch: false })

        this.closeInfobox$ = createEffect(() => this.actions$.pipe(
            ofType(GeneralMapActions.closeInfobox),
            tap(({ mapId, infoBoxType }) => {
                const isMeasureType =
                    infoBoxType === MapInfoBoxTypeEnum.measure_distance ||
                    infoBoxType === MapInfoBoxTypeEnum.measure_area

                // clear the yellow selection highlight only when closing a selection-type infobox
                // (closing a measurement must not wipe an underlying parcel/lpis highlight)
                if (
                    infoBoxType === MapInfoBoxTypeEnum.lpis ||
                    infoBoxType === MapInfoBoxTypeEnum.parcel ||
                    infoBoxType === MapInfoBoxTypeEnum.parcels_list ||
                    infoBoxType === MapInfoBoxTypeEnum.building
                ) {
                    this.generalMapLayerService.removeAllFeaturesFromLayerByName('highlight-overlay', mapId)
                }

                // skip features/header reset when closing a measurement — preserves parcel state for restoration
                if (!isMeasureType) {
                    this.store.dispatch(GeneralMapActions.setMapSimpleFeatures({ mapId, features: [] }))
                    this.store.dispatch(GeneralMapActions.setHeader({ mapId, value: null }))
                }

                if (infoBoxType === MapInfoBoxTypeEnum.measure_area || infoBoxType === MapInfoBoxTypeEnum.measure_distance) {
                    this.generalMapHelper.disableDrawing( mapId )
                }

                if (infoBoxType === MapInfoBoxTypeEnum.lpisUserSelection) {
                    this.store.dispatch(GeneralMapActions.lpisUserSelection({
                        mapId,
                        visible: false,
                        lpisConfig: null,
                        doNotUpdateMap: null,
                    }))
                    this.store.dispatch(LpisUserSubjectSearchActions.updateFilterCriteria({ criteriaFragment: { exceptLpisIds: [] } }))
                }

                // this.store.dispatch( GeneralMapActions.resetMapHighlight({ mapId }) // seems unused
                this.store.dispatch(GeneralMapActions.resetMapInfoBox({ mapId, showedInfoBox: infoBoxType }))
            }),
        ), { dispatch: false })

        this.updateLayerConfigPropertyByLayerId$ = createEffect(() => this.actions$.pipe(
            ofType(GeneralMapActions.updateLayerConfigPropertyByLayerId),
            map(action => {
                return GeneralMapActions.setMapSimpleLayersConfigPropertyByLayerId({
                    mapId: action.mapId,
                    layerId: action.layerId,
                    property: action.property,
                    value: action.value
                })
            })
        ))

        this.setMapSimpleLayersConfigPropertyByLayerId$ = createEffect(() => this.actions$.pipe(
            ofType(GeneralMapActions.setMapSimpleLayersConfigPropertyByLayerId),
            tap(action => {
                this.store.select(selectGeneralMapSaveLayersConfig(action.mapId)).pipe(take(1)).subscribe(({ saveLayersVisibility, storagePrefix, layersConfig }) => {
                    const propertiesToSave = ['visible', 'isSet', 'expDate', 'acreage', 'title', 'userIdent']

                    if (saveLayersVisibility && propertiesToSave.indexOf(action.property) > -1) {
                        this.generalMapHelper.saveLayers(action.mapId, layersConfig, storagePrefix)
                    }
                })
            })
        ), { dispatch: false })

        this.lpisUserSelection$ = createEffect(() => this.actions$.pipe(
            ofType(GeneralMapActions.lpisUserSelection),
            tap(action => {
                this.store.select(selectGeneralMapLayersConfig(action.mapId)).pipe(
                    take(1)
                ).subscribe(layersConfig => {
                    const newConfig = cloneDeep(layersConfig)
                    const lpisUserConfigGroup = this.mapLpisLayerService.getLpisUserConfigGroup(newConfig)

                    this.generalMapService.map$.pipe(
                        filter(map => map[action.mapId] !== null && map[action.mapId] !== undefined), // Check if map is not null or undefined
                        take(1), // Execute the code only once
                    ).subscribe(map => {
                        let visibleResolved
                        if (lpisUserConfigGroup) {
                            // switching window with list of lpis users
                            if(action.visible !== null && action.visible !== undefined) {
                                visibleResolved = action.visible
                                if (action.visible) {
                                    // add visible custom LPIS layers to map
                                    if (!action.doNotUpdateMap) {
                                        lpisUserConfigGroup.layers?.forEach( layerConfig => {
                                            if (layerConfig.visible) {
                                                const layer = this.openLayersLayerService.buildLayerFromDefinition(layerConfig, true)
                                                if (layer) {
                                                    map[action.mapId].addLayer(layer)
                                                }
                                            }
                                        })
                                        this.mapLpisLayerService.setLpisUserConfigGroup(newConfig, lpisUserConfigGroup)
                                    }
                                    // remove default lpis layer
                                    this.generalMapHelper.switchDefaultLpisLayer(action.mapId, newConfig, lpisUserConfigGroup.layers.length > 0)
                                } else {
                                    // remove custom layers from map
                                    lpisUserConfigGroup.layers?.forEach(layerConfig => this.openLayersMapService.removeLayerByName(layerConfig.id, map[action.mapId]))
                                    this.store.dispatch(GeneralMapActions.resetMapSimpleLayersOutsideSelector({mapId: action.mapId}))
                                    // remove layer from global map config
                                    lpisUserConfigGroup.layers = lpisUserConfigGroup.layers.filter((layer: any) => !layer.id.startsWith('lpis_user_'))
                                    this.mapLpisLayerService.setLpisUserConfigGroup(newConfig, lpisUserConfigGroup)

                                    let lpisForeignDefaultLayerConfig = this.generalMapHelper.getSelectorConfigById(newConfig, 'farmer-blocks-foreign')
                                    lpisForeignDefaultLayerConfig.isSet = false

                                    this.generalMapHelper.switchDefaultLpisLayer(action.mapId, newConfig, lpisUserConfigGroup.layers.length > 0)
                                    this.store.dispatch(LpisUserSubjectSearchActions.updateFilterCriteria({criteriaFragment: {exceptLpisIds: []}}))
                                }

                                this.generalMapHelper.updateLpisLayerTitle(newConfig, visibleResolved ? lpisUserConfigGroup.layers.length : 0)
                            } else {
                                // switching layer farmer-blocks-foreign
                                // layer is visible
                                this.store.dispatch(GeneralMapActions.updateLayerConfigPropertyByLayerId({mapId: action.mapId, layerId: lpisUserConfigGroup.id, property: 'visible', value: action.lpisConfig?.visible || false}))

                                if (action.lpisConfig?.visible) {
                                    visibleResolved = action.lpisConfig.isSet

                                    if (action.lpisConfig.isSet) {
                                        // show active custom lpis layers
                                        lpisUserConfigGroup.layers.forEach(layerConfig => this.generalMapHelper.addLayerToMap(action.mapId, layerConfig))
                                        this.mapLpisLayerService.setLpisUserConfigGroup(newConfig, lpisUserConfigGroup)

                                        this.generalMapHelper.switchDefaultLpisLayer(action.mapId, newConfig, lpisUserConfigGroup.layers.length > 0)
                                    } else {
                                        // isSet is false, show default lpis layer
                                        this.generalMapHelper.switchDefaultLpisLayer(action.mapId, newConfig, false)
                                    }
                                } else {
                                    // vypinam vrstvu
                                    visibleResolved = false
                                    // turn off custom lpis layers
                                    lpisUserConfigGroup.layers?.forEach((layerConfig: any) => {
                                        this.openLayersMapService.removeLayerByName(layerConfig.id, map[action.mapId])

                                        // we have to preserve visible flag regardless of map removal
                                        this.store.dispatch(GeneralMapActions.updateLayerConfigPropertyByLayerId({mapId: action.mapId, layerId: layerConfig.id, property: 'visible', value: true}))
                                    })
                                    this.mapLpisLayerService.setLpisUserConfigGroup(newConfig, lpisUserConfigGroup)
                                    if (action.doNotUpdateMap === true) {
                                        this.generalMapHelper.switchDefaultLpisLayer(action.mapId, newConfig, false)
                                    }
                                }
                            }

                            this.generalMapHelper.saveLayersConfig(action.mapId)
                            this.store.dispatch(GeneralMapActions.setLayersConfig({mapId: action.mapId, config: newConfig}))
                            if (visibleResolved) {
                                this.store.dispatch(GeneralMapActions.setMapInfoBox({ mapId: action.mapId, showedInfoBox: MapInfoBoxTypeEnum.lpisUserSelection }))
                            } else {
                                this.store.dispatch(GeneralMapActions.resetMapInfoBox({ mapId: action.mapId, showedInfoBox: MapInfoBoxTypeEnum.lpisUserSelection }))
                            }
                        }
                    })
                })
            }),
        ), { dispatch: false })

    }

    // private loadLayers(mapId: string, storagePrefix: string): any {
    //     return JSON.parse(localStorage.getItem((storagePrefix ? storagePrefix + '.' : '') + 'layerSelector.' + mapId))
    // }

    // /**
    //  * This mutates config params - it updates lpis_user_* layers with data from loadedConfig param.
    //  * @param loadedConfig
    //  * @param config
    //  * @private
    //  */
    // private initCustomLpisLayersInConfig(loadedConfig: any, config: any): void {
    //     const lpisForeignLayer = loadedConfig.find(config => config.id === 'farmer-blocks-foreign')
    //     // load custom LPIS-user layers
    //     this.store.dispatch(MapColorGeneratorActions.getNextColors({
    //         num: loadedConfig.filter(savedConfig => savedConfig.id.startsWith('lpis_user_')).length,
    //         ident: 'lpis',
    //     }))
    //     let colors$ = this.store.select(selectMapColorGeneratorColorMapByKey('lpis'))
    //
    //     colors$.pipe(take(1)).subscribe(colors => {
    //         const isSet = lpisForeignLayer.isSet === undefined ? false : lpisForeignLayer.isSet
    //         const lpisIds = []
    //         const lpisUserConfigGroup = cloneDeep(config)?.layers.find(layerGroup => layerGroup.id === 'lpis_user')
    //         let i = 0
    //         loadedConfig.forEach(savedConfig => {
    //             if (savedConfig.id.startsWith('lpis_user_')) {
    //                 const lpisId = parseInt(savedConfig.id.replace('lpis_user_', ''))
    //                 const layerConfig = this.mapLpisLayerService.getLpisLayerConfig(lpisId, colors[i++], {})
    //
    //                 layerConfig.visible = savedConfig.visible && isSet
    //                 layerConfig.title = savedConfig.title
    //                 layerConfig.userIdent = savedConfig.userIdent
    //                 layerConfig.acreage = savedConfig.acreage
    //
    //                 lpisUserConfigGroup.layers.push(layerConfig)
    //
    //                 lpisIds.push(lpisId)
    //             }
    //         })
    //         this.store.dispatch(LpisUserSubjectSearchActions.updateFilterCriteria({ criteriaFragment: { exceptLpisIds: lpisIds } }))
    //     })
    // }
    //
    // /**
    //  * Updates config visibility attribute from given config.
    //  * @param {Object} config
    //  * @param {Object} scopeConfig scope config object which will be returned
    //  */
    // private updateScopeConfigVisibility(config: Array<any>, scopeConfig: any): void {
    //     if (Array.isArray(config)) {
    //         let visibleOne = false
    //         config.forEach((value) => {
    //             const selConfig = this.generalMapHelper.getSelectorConfigById(scopeConfig, value.id)
    //             if (selConfig) {
    //                 selConfig.visible = value.visible
    //
    //                 if (value.isSet) {
    //                     selConfig.isSet = value.isSet
    //                 }
    //
    //                 if (value.expDate) {
    //                     selConfig.expDate = value.expDate
    //                 }
    //             }
    //
    //             if ((value.id === 'parcel_group' || value.id === 'contract_group') && value.visible === true && !selConfig) {
    //                 visibleOne = true
    //             }
    //         })
    //         // CA-12810 - if parcel_group layers group is empty, than its deleted from scopeConfig, but if
    //         // it was saved in local storage as visible before, there must be new visible group (the default one)
    //         // otherwise no groups switch box is visible
    //         if (visibleOne) {
    //             let selConfig = this.generalMapHelper.getSelectorConfigById(scopeConfig, 'parcel_owner')
    //             if (selConfig) {
    //                 selConfig.visible = true
    //             }
    //         }
    //
    //     }
    // }
}